export default {
  provide() {
    return {
      'tree': this,
      'treeNodeParent': this,
      'deep': 0
    };
  },
  props: {
    expandedIndexes: []
  },
  data() {
    return {
      nodes: {},
      dataExpandedIndexes: []
    };
  },
  watch: {
    expandedIndexes(v) {

    }
  },
  methods: {
    addNode(node) {
      this.nodes[node.index] = node;
    },
    removeNode(node) {
      delete this.nodes[node.index];
    },
    isExpanded(node) {
      return this.dataExpandedIndexes.indexOf(node.index) > -1;
    },
    toggleExpand(node) {
      if (this.isExpanded(node)) {
        this.setExpand(node, false);
      } else {
        this.setExpand(node, true);
      }
    },
    setExpand(node, expanded) {
      const index = node.getIndex();
      if (!expanded) {
        this.dataExpandedIndexes = this.dataExpandedIndexes.filter(
          eIndex => eIndex !== index
        );
      } else {
        const idx = this.dataExpandedIndexes.indexOf(index);
        if (idx === -1) {
          this.dataExpandedIndexes.push(index);
        }
      }
      this.$emit('update:expandedIndexes', this.dataExpandedIndexes);
    }
  }
};
